import { Checkbox, ListItem } from "@material-ui/core";
import { useState } from "react";
import { PricingGroupElement } from "../../api/PricingGroupApi";

interface Props {
  readonly pricingGroupElement: PricingGroupElement;
  readonly updated: boolean;
  readonly onMaterialToggled: (selected: boolean) => void;
}

const PricingGroupMaterialSelectableListItem = (props: Props) => {
  const pricingGroupElement = props.pricingGroupElement;
  const material = pricingGroupElement.material;
  const [materialSelected, setMaterialSelected] = useState<boolean>(false);

  const handleCheckboxChanged = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setMaterialSelected(checked);
    props.onMaterialToggled(checked);
  };

  return (
    <ListItem>
      <div>{`${material.name} : ${pricingGroupElement.unitCustomerPrice} (+ ${pricingGroupElement.unitProfitMargin})`}</div>
      <Checkbox
        edge="end"
        onChange={ handleCheckboxChanged }
        checked={ materialSelected }
      />
    </ListItem>
  )
};

export default PricingGroupMaterialSelectableListItem